import { render, staticRenderFns } from "./PhysicalActivityInfoItem.vue?vue&type=template&id=30c33734&"
import script from "./PhysicalActivityInfoItem.vue?vue&type=script&lang=js&"
export * from "./PhysicalActivityInfoItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports